<template>
  <a
    :href="API.DOWNLOAD_APP_URL"
    target="_blank"
    class="flex items-center px-[16px] py-[10px] z-10 bg-white rounded-xl text-back-2 text-sm font-medium cursor-pointer leading-[16px] mx-auto my-0">
    <vIcon name="appleDownload" class="w-4 h-4 mr-[5px]" />
    <vIcon name="googleDownload" class="w-4 h-4 mr-[12px]" />
    {{ t("other|sharedPages|downloadApp") }}
  </a>
</template>

<script setup>
import vIcon from "@/components/ui/icon.vue";
import { useI18n } from "vue-i18n";
import { API } from "@/api/constants";

const { t } = useI18n();
</script>
